/** The dashboard dialogs' buttons: the practice modals' look (Cancel, Confirm). */
export const GHOST_BUTTON = "btn text-primary-foreground rounded-xl shadow hover:bg-white"
export const BLUE_BUTTON = "btn rounded-xl bg-blue-600 text-[14px] capitalize text-white"
/** The practice modals' blue, inline: the dashboard's own Tailwind build may not carry bg-blue-600. */
export const BLUE_STYLE = { background: "#155dfc", color: "#ffffff" } as const
